<template>
    <el-amap vid="amapDemo" :zoom="zoom" :center="center" :scrollWheel="scrollWheel">
        <el-amap-marker  v-for="(marker,index) in markers" :position="marker.position" :key="index">
        </el-amap-marker>
        <el-amap-info-window v-for="(window,index) in windows" :position="window.position" :content="window.content" :open="window.open" :key="index"></el-amap-info-window>
    </el-amap>
</template>

<script>
    export default {
        data() {
            return {
                isTransparent: false,
                zoom: 14,
                center: [113.941472,22.312837],
                scrollWheel: false,
                markers: [],
                windows: [
                    {
                        content:'抵港層（L3）旅遊車總站，香港國際機場 Coach Station, Arrivals Level (L3)，Hong Kong International Airport',
                        position: [113.941472,22.312837]
                    }
                ]
            }
        },
        mounted() {
            // 姑且N为2
            // 这样地图上就添加了两个人
            this.markers = [
                {
                    position: [113.941472,22.312837]
                }
            ]
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// StoreHK.vue?2f3cb552